import React from 'react';
import { createRoot } from 'react-dom/client';
import { Ticker } from './Ticker.jsx';
import '@fec/frontend/foundation/translations/react_i18n_init.js';
import Urn from '@fec/frontend/foundation/client/urn.js';

export function init() {
  const tickerRoot = document.getElementById('ticker');
  const articleUrn = document
    .querySelector('meta[name="srf:urn"]')
    .getAttribute('content');

  const oldLegacyChannelName = `public:article:${Urn.getId(articleUrn)}`;
  const oldLegacyApiEndpoint = `/article/${articleUrn}/liveticker`;

  const root = createRoot(tickerRoot);
  root.render(
    <Ticker
      active={tickerRoot.dataset.active}
      label={tickerRoot.dataset.label}
      startTime={new Date(tickerRoot.dataset.startTime)}
      accessToken={tickerRoot.dataset.token}
      channelName={tickerRoot.dataset.channel ?? oldLegacyChannelName}
      apiEndpoint={tickerRoot.dataset.apiEndpoint ?? oldLegacyApiEndpoint}
    />,
  );
}
